"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncFormStyleContainer = AsyncFormStyleContainer;
exports.AsyncCollectedFormsContainer = AsyncCollectedFormsContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var FormStyleContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/FormStyleContainer'
    /* webpackChunkName: "chunk-marketing-form" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncFormStyleContainer(props) {
  return _react.default.createElement(FormStyleContainer, props);
}

var CollectedFormsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('../collected-forms/containers/CollectedFormsContainer'
    /* webpackChunkName: "chunk-marketing-form" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncCollectedFormsContainer(props) {
  return _react.default.createElement(CollectedFormsContainer, props);
}